import styled from "styled-components";

const DonationContainer = styled.div`
  img {
    width: 100%;
  }
  .SubTitle {
    text-align: left;
    margin-bottom: 1%;
    img {
      width: 2em;
      vertical-align: middle;
      height: 100%;
    }
    a {
      font-size: 1rem;
      padding: 0.2em 1em;
      text-decoration: none;
      color: white;
      background-color: rgb(22, 171, 193);
      border: none;
      border-radius: 5px;
      box-shadow: 2px 3px 8px 1px rgb(22, 171, 193);
      margin-left: 1em;
      cursor: pointer;
      &:hover {
        color: #000;
      }
    }
  }
  @media only screen and (max-width: 480px) {
    .SubTitle {
      padding-left: 2%;
      span {
        font-size: 0.8rem;
        word-break: keep-all;
      }
    }
  }
`;
export default DonationContainer;
